import React , {Component} from 'react';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton , Popup , Navbar , NavRight
} from 'framework7-react';
import NumberFormat from 'react-number-format';

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import * as axios from "axios/index";
import validator from "validator";
import Loading from "../Loader/Loading";
import OrdersListLoader from "../Loader/OrdersListLoader";
import OrderCard from "../Cards/OrderCard";
import * as vars from './Vars';
import LoginSingUp from './LoginSingUp';

class OrdersList extends Component{



    onPageBeforeIn(){
        this.props.toolbar(true)
    }


    constructor(props){
        super(props)
        this.state = {
            goToLoginSignUp : localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null ,
            requestLoading : true ,
            orders : [] ,
            orderView : "active"

        }
    }
    componentWillMount(){

       /* if (localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null)
        {
            this.$f7router.navigate('/login-singup/')
            return
        }*/


       if (this.state.goToLoginSignUp ===false)
       {

        let data = new FormData()
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )

        axios.post(vars.PreUrl + 'https://www.lavefood.com/v1/orders/list' , data )
            .then(response => {

                let data = response.data.result[0]
                console.log(data)
                if (data.error === 0)
                {
                    this.setState({
                        orders : data.orders ,
                        requestLoading : false ,
                    })
                }




            })
            .catch(error => {
                console.log(error)
            })
       }


    }

    activeOrderShow(){
        this.setState({
            orderView : "active"
        })
    }

    olderOrderShow(){
        this.setState({
            orderView : "older"
        })
    }

    render(){

        if(this.state.goToLoginSignUp === true)
            return(
                <LoginSingUp />
            )
        else
        return(
            <Page name="ordersList" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header" >

                    <Link href="/" id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        پیشینه سفارشات
                    </div>
                </div>
                <div id="inner-header-separator" />

                {
                    this.state.requestLoading === true ?
                        (<OrdersListLoader  />) : (
                            <div id="orders-list">

                                <div id="header">
                                    <div className="b-row">
                                        <div className="b-col-6 text-left">
                                            <div  className={this.state.orderView === "active" ? 'btn btn-custom active' : 'btn btn-custom'} onClick={this.activeOrderShow.bind(this)}>
                                                سفارشات فعال
                                            </div>
                                        </div>
                                        <div className="b-col-6 text-right">
                                            <div className={this.state.orderView === "older" ? 'btn btn-custom active' : 'btn btn-custom'} onClick={this.olderOrderShow.bind(this)}>
                                                سفارشات قبل
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={this.state.orderView === "active" ? 'order-container active' : 'order-container'}>


                                    {this.state.orders.map( function(object , index){

                                        if (parseInt(object.step) !== 105 && parseInt(object.step) !== 103 && parseInt(object.step) !== 301){
                                            return (
                                                <OrderCard object={object} key={index}  />
                                            )
                                        }
                                        return '';

                                    }  )}

                                </div>
                                <div className={this.state.orderView === "older" ? 'order-container active' : 'order-container'}>
                                    {this.state.orders.map( function(object , index){

                                        if (parseInt(object.step) === 105 || parseInt(object.step) === 103 || parseInt(object.step) === 301){
                                            return (
                                                <OrderCard object={object} key={index} />
                                            )
                                        }
                                        return '';

                                    }  )}
                                </div>

                            </div>



                        )
                }











            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch ,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(OrdersList);